import { render, staticRenderFns } from "./gradeAdditionsForm.vue?vue&type=template&id=ba52a316&scoped=true"
import script from "./gradeAdditionsForm.vue?vue&type=script&lang=js"
export * from "./gradeAdditionsForm.vue?vue&type=script&lang=js"
import style0 from "./gradeAdditionsForm.vue?vue&type=style&index=0&id=ba52a316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba52a316",
  null
  
)

export default component.exports